import React, { useEffect, useState } from "react";
import Button from "../../../components/Buttons/Button";
import IconButton from "../../../components/Buttons/IconButton";
import SaveButton from "../../../components/Buttons/SaveButton";
import ColorPickerControl from "../../../components/Fields/ColorPickerControl";
import ColorPickerField from "../../../components/Fields/ColorPickerField";
import SelectListControl from "../../../components/Fields/SelectListControl";
import SelectListField from "../../../components/Fields/SelectListField";
import TextboxControl from "../../../components/Fields/TextboxControl";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { Translate } from "../../../components/Translate";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemRevisionColorModel from "../../../models/ItemRevisionColorModel";
import DataService from "../../../services/data.service";
import { Result } from "../../../types/Result";
import DeleteItemRevisionColorPopup from "./ItemRevision_popup_DeleteItemRevisionColor";

interface IProps {
    show: boolean
    onHide: (updatedItemColors?: ItemRevisionColorModel[]) => void
    onDelete: (itemRevisionColorId: number) => void
    itemColors: ItemRevisionColorModel[]
    parentItemId?: number

}

const EditItemColorsPopup: React.FC<IProps> = ({ show, onHide, onDelete, itemColors, parentItemId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleResults, handleException } = useNotifications();
    const [tableData, setTableData] = useState<ItemRevisionColorModel[]>([]);
    const [selectedColor, setSelectedColor] = useState<ItemRevisionColorModel>()
    const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);

    const colors = useSelectListOptions('api/v1/selectlist/Colors?activeOnly=true', '-- Select color');

    useEffect(() => {
        setTableData(itemColors)
    }, [itemColors])

    function submit() {
        if (tableData) {
            DataService
                .updateTableData<ItemRevisionColorModel>(`api/v1/ItemRevisionColors/UpdateMultiple`, tableData)
                .then(response => {
                    handleResults(response, true);
                    if (response.filter(x => x.isSuccesful == false).length === 0) {
                        let items: ItemRevisionColorModel[] = []
                        response.forEach(x => {
                            if (x.data)
                                items.push(x.data)
                        })
                        onHide(items);
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function deleteColor(itemRevisionColor: ItemRevisionColorModel) {
        setSelectedColor(itemRevisionColor)
        setShowDeletePopup(true)
    }

    const formConfig: FormConfig = {
        fields: [],
        handleSubmit: submit,
        showErrors: 'always',
    };

    tableData.forEach((color, index) => {
        formConfig.fields.push({ name: `${index}.colorItemNr`, label: 'ItemNr', labelSize: 3 })
        formConfig.fields.push({ name: `${index}.color.name`, label: 'Color', labelSize: 3, validationRules: [{ type: 'isMaxLength', maxLength: 100 }] })
        formConfig.fields.push({ name: `${index}.color.colorFamily`, label: 'Color', labelSize: 3, validationRules: [{ type: 'isMaxLength', maxLength: 100 }] })
        formConfig.fields.push({ name: `${index}.alternativeName`, label: 'Alternative name', labelSize: 3, validationRules: [{ type: 'isMaxLength', maxLength: 100 }] })
        formConfig.fields.push({ name: `${index}.alternativeColorCode`, label: 'Alternative color code', labelSize: 3, validationRules: [{ type: 'isMaxLength', maxLength: 50 }] })
    })

    const { getControlProps, getSubmitButtonProps } = useValidation(formConfig, tableData, serverErrors);

    return (
        <>
        <Popup show={show} onHide={onHide} size={'xxl'} title={'Edit colors'} >
            <Popup.Body>
                <div className='plm-datatable' >
                    <div className='plm-datatable-wrapper' >
                        <table className='table table-bordered table-striped'>
                            <thead className='plm-datatable-thead'>
                                <tr>
                                    <th style={{ width: 200 }}><Translate>ItemNr</Translate></th>
                                    <th style={{ width: 150 }}><Translate>Color</Translate></th>
                                    <th style={{ width: 150 }}><Translate>Familiy</Translate></th>
                                    <th><Translate>Name</Translate></th>
                                    <th><Translate>Pantone Color</Translate></th>
                                    <th><Translate>Color code</Translate></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody className='plm-datatable-tbody'>
                                    {
                                        tableData.map((color, index) => {
                                    return <tr>
                                        <td><TextboxControl {...getControlProps(`${index}.colorItemNr`)} disabled /></td>
                                        <td><TextboxControl {...getControlProps(`${index}.color.name`)} disabled /></td>
                                        <td><TextboxControl {...getControlProps(`${index}.color.colorFamily`)} disabled /></td>
                                        <td><TextboxControl {...getControlProps(`${index}.alternativeName`)} /></td>
                                        <td><TextboxControl {...getControlProps(`${index}.pantoneColor`)} /></td>
                                        <td><ColorPickerControl {...getControlProps(`${index}.alternativeColorCode`)} /></td>
                                        <td>{!parentItemId && < IconButton icon='fa-trash' variant='danger' onClick={() => deleteColor(color)} />}</td>
                                    </tr>
                                })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} />
            </Popup.Footer>
            </Popup>
            {showDeletePopup && selectedColor  && <DeleteItemRevisionColorPopup show={showDeletePopup} onHide={() => setShowDeletePopup(false)} onDelete={onDelete} itemRevisionColor={selectedColor} />}
        </>
    );
}
export default EditItemColorsPopup;